/** @prettier */
import className from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import {
  NO_MATCHED_BETS_MESSAGE,
  STREAMING_COUNTRY_BLOCKED,
  STREAMING_NOT_AVAILABLE_MESSAGE,
} from '@xanadu/ui-shared/modules/streaming/utils';

import Currency from '../../../containers/Currency';

import styles from './Locked.module.scss';

export default function Streaming({
  isLoggedIn,
  loginRequest,
  streamError,
  hide,
  extraClass,
  eventFinished,
  mobileStream,
  sportUrlName,
  minimumBetAmount,
}) {
  const mainClass = className({
    [styles.locked]: true,
    [styles['locked--hide']]: hide,
    [styles['locked--back']]: extraClass !== '',
    [styles['locked--mobile']]: !!mobileStream,
  });

  const placeholderClass = className({
    [styles.lockedPlaceholder]: true,
    [styles[`lockedPlaceholder--${sportUrlName}`]]: true,
    [styles['lockedPlaceholder--mobile']]: !!mobileStream,
  });

  const placeholderControlsClass = className({
    [styles.controls]: true,
    [styles.placeholderControls]: true,
  });

  if (!isLoggedIn) {
    return (
      <div
        role="button"
        onClick={() => {
          loginRequest();
        }}
        className={mainClass}
      >
        {!mobileStream && <div className={styles.header}>Matchbook Live Stream</div>}
        <div className={placeholderClass} />
        <div className={placeholderControlsClass}>
          <div className={styles.lockedText}>Log in to watch</div>
        </div>
      </div>
    );
  } else if (eventFinished) {
    return (
      <div className={mainClass}>
        {!mobileStream && <div className={styles.header}>Matchbook Live Stream</div>}
        <div className={placeholderClass} />
        <div className={placeholderControlsClass}>
          <div className={styles.finishedText}>This event has now finished</div>
        </div>
      </div>
    );
  } else if (streamError === NO_MATCHED_BETS_MESSAGE) {
    return (
      <div className={mainClass}>
        {!mobileStream && <div className={styles.header}>Matchbook Live Stream</div>}
        <div className={placeholderClass} />
        <div className={placeholderControlsClass}>
          <div className={styles.lockedText}>
            Bet <Currency value={minimumBetAmount} /> to watch
          </div>
        </div>
      </div>
    );
  } else if (streamError === STREAMING_COUNTRY_BLOCKED) {
    return (
      <div className={mainClass}>
        {!mobileStream && <div className={styles.header}>Matchbook Live Stream</div>}
        <div className={placeholderClass} />
        <div className={placeholderControlsClass}>
          <div className={styles.lockedText}>This streaming is not available in your country</div>
        </div>
      </div>
    );
  } else if (streamError === STREAMING_NOT_AVAILABLE_MESSAGE) {
    return (
      <div className={mainClass}>
        {!mobileStream && <div className={styles.header}>Matchbook Live Stream</div>}
        <div className={placeholderClass} />
        <div className={placeholderControlsClass}>
          <div className={styles.lockedText}>
            Streaming will be available shortly before the race
          </div>
        </div>
      </div>
    );
  }

  return null;
}

Streaming.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
  loginRequest: PropTypes.func.isRequired,
  streamError: PropTypes.string,
  hide: PropTypes.bool.isRequired,
  extraClass: PropTypes.string,
  sportUrlName: PropTypes.string,
  eventFinished: PropTypes.bool,
  mobileStream: PropTypes.bool,
  minimumBetAmount: PropTypes.number,
};
